<template>
    <div>
        <b-button :disabled="isDataSending" class="text-uppercase" style="height: 32px; line-height: 15px" variant="custom-green" @click="showExportModal = true">Выгрузить реестр договоров в .XLSX</b-button>

        <b-modal v-model="showExportModal" centered hide-header-close no-close-on-backdrop no-close-on-esc title="Выгрузка реестра договоров в .XLSX" size="lg">
            <form-row-edit-date label="Дата заключения договора, С" :label-cols-sm="6" :label-cols-lg="6" v-model="exportRequest.fromContractDate" :max-date="exportRequest.toContractDate" />
            <form-row-edit-date label="Дата заключения договора, По (включительно)" :label-cols-sm="6" :label-cols-lg="6" v-model="exportRequest.toContractDate" :min-date="exportRequest.fromContractDate" />

            <div slot="modal-footer" class="w-100 text-right">
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase mr-2" variant="custom-outline-secondary" @click="handleCancel">Отмена</b-button>
                </b-overlay>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase" variant="custom-green" @click="handleAccept">Выгрузить</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import FileDownload from 'js-file-download';

export default {
    name: 'cabinet-fl223-contracts-export-button',
    data() {
        return {
            showExportModal: false,
            exportRequest: {
                fromContractDate: null,
                toContractDate: null
            },
            isDataSending: false
        };
    },
    methods: {
        handleAccept() {
            this.isDataSending = true;
            this.$api.personal.fl223
                .getContractsXlsExport(this.getFilters())
                .then((response) => {
                    FileDownload(response.data, 'Договора.xlsx');
                })
                .finally(() => {
                    this.handleCancel();
                });
        },
        getFilters() {
            const filterValues = [];
            for (const [key, value] of Object.entries(this.exportRequest)) {
                if (value) {
                    filterValues[key] = value;
                }
            }
            return { ...filterValues };
        },
        handleCancel() {
            this.showExportModal = false;
            this.exportRequest.fromContractDate = null;
            this.exportRequest.toContractDate = null;
            this.isDataSending = false;
        }
    }
};
</script>

<style scoped>
input::-webkit-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input:-moz-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::-moz-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input:-ms-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::-ms-input-placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input::placeholder {
    color: #959ba4 !important;
    opacity: 0.5 !important;
}

input {
    border-color: rgba(149, 155, 164, 0.2);
}

.tabs li + li {
    padding-left: 20px;
}

.tabs li {
    font-size: 14px;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    border-bottom: 1px solid var(--grey-color);
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.tabs li a {
    color: var(--grey-color);
    text-decoration: none;
    border-bottom: 2px solid transparent;
}
</style>
